import {
  LOGOUT_COMPLETE,
  SPLITTER_RESET,
  SPLITTER_SET_ATTR,
  SPLITTER_SET_EXPRESSIONS,
  SPLITTER_SET_FALLBACK,
  SPLITTER_SET_LAST_TX_PAYLOAD,
  SPLITTER_SET_LOADING,
  SPLITTER_SET_MODE,
  SPLITTER_SET_VALUES,
} from 'js/constants/actionTypes';
import {
  FALLBACK_DISCARD,
  FALLBACK_NEW_NEXSET,
  MODE_EXPRESSIONS,
} from 'new/components/SplitDataSet/DataSetSplitDialog';
import { ExpressionItem } from 'new/components/SplitDataSet/ExpressionsEditor';
import { ValueItem } from 'new/components/SplitDataSet/ValuesEditor';
import { AnyAction } from 'redux';

export interface SplitterState {
  mode: string;
  fallback: string;
  expressions: ExpressionItem[];
  attr: string | null;
  values: ValueItem[];
  isLoading: boolean;
  lastTxPayload: any;
}

export const splitterReducer = (state: SplitterState | undefined, action: AnyAction) => {
  if (!state) {
    return getInitialState();
  }

  switch (action.type) {
    case SPLITTER_SET_MODE:
      return setMode(state, action);

    case SPLITTER_SET_FALLBACK:
      return setFallback(state, action);

    case SPLITTER_SET_EXPRESSIONS:
      return setExpressions(state, action);

    case SPLITTER_SET_ATTR:
      return setAttr(state, action);

    case SPLITTER_SET_VALUES:
      return setValues(state, action);

    case SPLITTER_SET_LOADING:
      return setLoading(state, action);

    case SPLITTER_SET_LAST_TX_PAYLOAD:
      return setLastTxPayload(state, action);

    case SPLITTER_RESET:
    case LOGOUT_COMPLETE:
      return getInitialState();

    default:
      return state;
  }
};

function setMode(state: SplitterState, action: AnyAction) {
  const { mode } = action.payload;

  return {
    ...state,
    mode,
  };
}

function setFallback(state: SplitterState, action: AnyAction) {
  const { fallback } = action.payload;

  return {
    ...state,
    fallback,
  };
}

function setExpressions(state: SplitterState, action: AnyAction) {
  const { expressions } = action.payload;

  return {
    ...state,
    expressions,
  };
}

function setAttr(state: SplitterState, action: AnyAction) {
  const { attr } = action.payload;

  return {
    ...state,
    attr,
  };
}

function setValues(state: SplitterState, action: AnyAction) {
  const { values } = action.payload;

  return {
    ...state,
    values,
  };
}

function setLoading(state: SplitterState, action: AnyAction) {
  const { loading } = action.payload;

  return {
    ...state,
    isLoading: loading,
  };
}

function setLastTxPayload(state: SplitterState, action: AnyAction) {
  const { transform } = action.payload;

  return {
    ...state,
    lastTxPayload: transform,
  };
}

function getInitialState() {
  return {
    mode: MODE_EXPRESSIONS,
    fallback: FALLBACK_DISCARD,
    expressions: [
      {
        __id: crypto.randomUUID(),
        code: '',
        name: 'Output 1',
      },
    ],
    attr: null,
    values: [
      {
        __id: crypto.randomUUID(),
        valueList: [''] as (string | number | boolean)[],
      },
    ],
    isLoading: false,
    lastTxPayload: null,
  };
}
